import moment from 'moment';
import APIS from '../../constant/EndPoint';
import useGetHook from '../../customHooks/useGetHook';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import usePostHook from '../../customHooks/usePostHook';
import { responsiveClassName } from '../../utils/classNames';
import RecursiveComment from '../Reusable/RecursiceComment';
import ShareIcon from '../../Icons/ShareIcon';
import CheckIcon from '../../Icons/CheckIcon';
import ClipboardIcon from '../../Icons/ClipboardIcon';
import useTenantGetHook from '../../customHooks/useTenantControlGetHook';
import CrossIcon from '../../Icons/CrossIcon';
import CommentIcon from '../../Icons/CommentIcon';

const OrderDetailPage = ({ selectedOrder }: any) => {
  const { handleSubmit, register, setError, reset } = useForm({});
  const [comment, setComment] = useState<any>();
  const { data: remarks, refetch } = useGetHook({
    queryKey: [`remakrs-${selectedOrder}`],
    url: APIS.COMMENT,
    params: {
      limit: 200,
      offset: 0,
      object_id: selectedOrder,
    },
  });
  const { data: profile, isLoading } = useGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });
  const { data: orderHistory } = useGetHook({
    queryKey: [`order-hsitory-${selectedOrder}`],
    url: APIS.ORDER_HISTORY,
    params: {
      limit: 200,
      offset: 0,
      field_name: 'delivery_status',
      object_id: selectedOrder,
    },
  });

  const { data: order, isLoading: isDetailLoading } = useGetHook({
    queryKey: [`order-${selectedOrder}`],
    url: `${APIS.ORDER}${selectedOrder}/`,
    params: {},
  });
  const { data: returnData } = useGetHook({
    queryKey: [`rtv-${selectedOrder}`],
    url: `${APIS.RTV}`,
    params: {
      order_id: selectedOrder,
    },
  });
  const { data: runsheetData } = useGetHook({
    queryKey: [`runsheet-${selectedOrder}`],
    url: `${APIS.RUNSHEET}`,
    params: {
      order_id: selectedOrder,
    },
  });
  const { data: InvoiceData } = useGetHook({
    queryKey: [`invoice-${selectedOrder}`],
    url: `${APIS.INVOICE}`,
    params: {
      order_id: selectedOrder,
    },
  });
  const { data: ReceiverDetails } = useGetHook({
    queryKey: [`receiver-details-${selectedOrder}`],
    url: APIS.RECEIVER_DETAIL,
    params: {
      order: selectedOrder,
    },
  });
  const { data: websiteData } = useTenantGetHook({
    url: APIS.WEBSITE,
    queryKey: ['get-website'],
    params: {},
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: [`remakrs-${selectedOrder}`],
  });

  const handleCreateReview = async (data: any, id: any) => {
    const url = `${APIS.COMMENT}`;
    let formData = {
      ...data,
      branch: profile?.default_branch?.id,
      parent: id,
      object_id: selectedOrder,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        reset();
        setComment(null);
        refetch();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const [copied, setCopied] = useState(false);

  const trackingUrl = `https://${websiteData?.domain}/track?search=${order?.tracking_number}`;

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(trackingUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };
  const handleDownload = async () => {
    const fileURL = ReceiverDetails?.[0]?.identity_image;
    const fullName = ReceiverDetails?.[0]?.full_name;
    if (!fileURL || !fullName) {
      console.error('Invalid file URL or Receiver details.');
      return;
    }
    try {
      const response = await fetch(fileURL);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const blob = await response.blob();

      const a = document.createElement('a');
      const objectURL = URL.createObjectURL(blob);
      a.href = objectURL;
      a.style.display = 'none';
      a.download = `Receiver Document - ${fullName}`;
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(objectURL);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error downloading the file:', error);
    }
  };

  return (
    <>
      <div className={tw` bg-white py-2 relative  `}>
        <div className={tw`flex justify-around text-3xl font-bold col-span-4`}>
          <div className={tw`text-sm md:text-2xl`}>
            {isDetailLoading ? <Loader /> : order?.pickup_branch?.name}
          </div>
          <div className={tw`text-sm md:text-2xl`}>---------</div>
          <div className={tw`text-sm md:text-2xl`}>
            {isDetailLoading ? <Loader /> : order?.destination?.name}
          </div>
        </div>
        <div className={tw`flex items-center gap-x-2 absolute -top-7 right-8`}>
          <div className={tw`relative group`}>
            <a
              href={trackingUrl}
              target='_blank'
              rel='noopener noreferrer'
              className={tw`focus:outline-none`}
            >
              <ShareIcon />
            </a>
            <span
              className={tw`absolute left-1/2 -translate-x-1/2 -top-6 text-xs bg-gray-800 text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity`}
            >
              Share
            </span>
          </div>
          <div className={tw`relative group mt-2`}>
            <button
              onClick={copyToClipboard}
              className={tw`focus:outline-none`}
            >
              {copied ? <CheckIcon /> : <ClipboardIcon />}
            </button>
            <span
              className={tw`absolute left-1/2 -translate-x-1/2 -top-6 text-xs bg-gray-800 text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity`}
            >
              {copied ? 'Copied!' : 'Copy'}
            </span>
          </div>
        </div>
        <div
          className={responsiveClassName(
            'grid grid-cols-1  mt-2 border ',
            `grid grid-cols-2  mt-2 border  `
          )}
        >
          <div className={tw`border-r-[1px]`}>
            <p
              className={tw`md:text-md w-full font-semibold whitespace-nowrap text-center`}
            >
              Order Details
            </p>

            <div
              className={responsiveClassName(
                'flex flex-col justify-center items-center  px-2 ',
                ' flex flex-row justify-between px-4 '
              )}
            >
              <div className={tw`text-sm whitespace-nowrap`}>
                <p className={tw`font-bold`}>
                  Waybill:{' '}
                  {isDetailLoading ? <Loader /> : order?.tracking_number}
                </p>
                <p className={tw``}>
                  Ref. Number:{' '}
                  {isDetailLoading ? <Loader /> : order?.reference_number}
                </p>
                <p>COD: {isDetailLoading ? <Loader /> : order?.cod}</p>
              </div>
              <div className={tw`text-sm whitespace-nowrap`}>
                <p>
                  Date:
                  {isDetailLoading ? (
                    <Loader />
                  ) : (
                    <span className={tw``}>
                      {moment(order?.created).format('YY-MM-DD HH:mm:ss')}
                    </span>
                  )}
                </p>
                <p>
                  Weight: {isDetailLoading ? <Loader /> : order?.total_weight}{' '}
                  Kgs
                </p>
                <p>
                  Piece: {isDetailLoading ? <Loader /> : order?.total_piece}
                </p>
                <p>
                  Collected COD:
                  {isDetailLoading ? <Loader /> : order?.collected_cod}
                </p>
              </div>
            </div>
          </div>
          <div
            className={responsiveClassName(
              ' flex flex-col justify-center items-center px-2',
              'flex flex-row justify-between px-4'
            )}
          >
            <div>
              <p className={tw` font-semibold`}>Sender</p>
              <div className={tw`text-sm`}>
                <p className={tw`capitalize`}>
                  Name:{' '}
                  {isDetailLoading ? <Loader /> : order?.sender?.full_name}
                </p>
                <p className={tw`flex flex-row`}>
                  Phone:
                  <p className={tw`text-sm text-gray-500 block`}>
                    {isDetailLoading ? (
                      <Loader />
                    ) : (
                      order?.sender?.primary_contact
                    )}
                  </p>
                </p>
                <p>
                  Location:{' '}
                  {isDetailLoading ? <Loader /> : order?.sender?.address}
                </p>
              </div>
            </div>
            <div>
              <p className={tw` font-semibold`}>Receiver</p>
              <div className={tw`text-sm`}>
                <p>
                  Name:{' '}
                  {isDetailLoading ? <Loader /> : order?.receiver?.full_name}
                </p>
                <p className={tw`flex flex-row`}>
                  Phone:
                  <p className={tw`text-sm text-gray-500 block`}>
                    {isDetailLoading ? (
                      <Loader />
                    ) : (
                      order?.receiver?.primary_contact
                    )}
                  </p>
                </p>
                <p className={tw`text-wrap `}>
                  Location:{' '}
                  {isDetailLoading ? <Loader /> : order?.receiver?.address}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className='flex justify-between'>
          <p>
            <span className={tw`font-bold`}>
              Description &#40;Note&#41; &#58;
            </span>
            {isDetailLoading ? <Loader /> : order?.delivery_instruction}
          </p>
          <p className={tw`font-bold`}>
            Service Type:
            {isDetailLoading ? <Loader /> : order?.service_type?.name ?? 'N/A'}
          </p>
        </div>
        <div
          className={responsiveClassName(
            'grid grid-cols-1 gap-x-4',
            'grid grid-cols-2 gap-x-4'
          )}
        >
          <div className={tw`container mx-auto mt-5 overflow-auto`}>
            <table className={tw`min-w-full bg-white border`}>
              <thead>
                <tr
                  className={tw`bg-gray-200 text-gray-600 uppercase text-[12px] leading-normal`}
                >
                  <th className={tw`py-2 px-6 text-left border `} colSpan={2}>
                    Main Order
                  </th>
                  <th className={tw`py-2 px-6 text-left border`} colSpan={2}>
                    Rider Information
                  </th>
                </tr>
                <tr
                  className={tw`text-gray-600 uppercase text-[12px] leading-normal`}
                >
                  <th className={tw`py-2 px-6 text-left border`}>Inv ID</th>
                  <th className={tw`py-2 px-6 text-left border`}>
                    RTV/Return ID
                  </th>
                  <th className={tw`py-2 px-6 text-left border`}>Name</th>
                  <th className={tw`py-2 px-6 text-left border`}>Phone no.</th>
                </tr>
              </thead>
              <tbody className={tw`text-gray-600 text-[12px] font-light`}>
                <tr className={tw`border-b border-gray-200 hover:bg-gray-100`}>
                  <th className={tw`py-3 px-6 text-left border`}>
                    {InvoiceData?.invoice_id ?? 'N/A'}
                  </th>
                  <th className={tw`py-3 px-6 text-left border`}>
                    {returnData?.rtv_order_id ?? 'N/A'}
                  </th>
                  <th className={tw`py-3 px-6 text-left border`}>
                    {runsheetData?.name ?? 'N/A'}
                  </th>
                  <th className={tw`py-3 px-6 text-left border`}>
                    {runsheetData?.phone_number ?? 'N/A'}
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
          <div className={tw`container mx-auto mt-5 overflow-auto`}>
            <table className={tw`min-w-full bg-white border`}>
              <thead>
                <tr
                  className={tw`bg-gray-200 text-gray-600 uppercase text-[12px] leading-normal`}
                >
                  <th className={tw`py-2 px-6 text-left border`} colSpan={2}>
                    <p>Proof of Delivery </p>
                  </th>
                  <th className={tw`py-2 px-6 text-left border `} colSpan={2}>
                    {ReceiverDetails?.[0]?.identity_image ? (
                      <p
                        className={tw`text-right cursor-pointer`}
                        onClick={() => handleDownload()}
                      >
                        Download{' '}
                      </p>
                    ) : (
                      ''
                    )}
                  </th>
                </tr>
                <tr
                  className={tw`text-gray-600 uppercase text-[12px] leading-normal `}
                >
                  <th className={tw`py-2 px-6 text-left border`}>Name</th>
                  <th className={tw`py-2 px-6 text-left border`}>Phone No.</th>
                  <th className={tw`py-2 px-6 text-left border`}>id</th>
                  <th className={tw`py-2 px-6 text-left border`}>Signature</th>
                </tr>
              </thead>
              <tbody className={tw`text-gray-600 text-[12px] font-light`}>
                <tr className={tw`border-b border-gray-200 hover:bg-gray-100`}>
                  <th className={tw`py-2 px-6 text-left border`}>
                    {ReceiverDetails?.[0]?.full_name ?? 'N/A'}
                  </th>
                  <th className={tw`py-2 px-6 text-left border`}>
                    {ReceiverDetails?.[0]?.primary_contact ?? 'N/A'}
                  </th>
                  <th className={tw`py-2 px-6 text-left border`}>
                    <p className={tw`uppercase`}>
                      {ReceiverDetails?.[0]?.identity}
                    </p>
                    <p>{ReceiverDetails?.[0]?.identity_number ?? 'N/A'}</p>
                  </th>
                  <th className={tw`border bg-white  `}>
                    {ReceiverDetails?.[0]?.signature ? (
                      <img
                        src={ReceiverDetails?.[0]?.signature}
                        className={tw`object-contain h-20 w-full`}
                      />
                    ) : (
                      ''
                    )}
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div
        className={responsiveClassName(
          'grid grid-cols-1  text-lg font-semibold',
          'grid grid-cols-2  text-2xl font-semibold'
        )}
      >
        <div className={tw` `}>
          <p>Order History</p>
          <div className={tw`max-h-[40svh] overflow-y-auto`}>
            <div className={tw`flex flex-col md:grid text-gray-50 mt-2`}>
              {orderHistory?.results?.map((item, index) => (
                <div className={tw`flex contents`} key={index}>
                  <div className={tw`col-start-2 col-end-4 mx-auto relative`}>
                    <div
                      className={tw`h-full w-6 flex items-center justify-center`}
                    >
                      <div
                        className={tw`h-full w-1 bg-green-500 pointer-events-none`}
                      ></div>
                    </div>
                    <div
                      className={tw`w-6 h-6 absolute top-1/2 -mt-3 rounded-full bg-green-500 shadow text-center`}
                    >
                      <i className={tw`fas fa-check-circle text-white`}></i>
                    </div>
                  </div>
                  <div
                    className={tw`bg-green-500 col-start-4 col-end-12 px-2 py-1 rounded-lg my-2 mr-auto shadow-md w-full `}
                  >
                    <h3 className={tw`font-semibold text-base`}>
                      {item?.new_data}&nbsp;by&nbsp;
                      {item?.user?.name}
                    </h3>
                    <div
                      className={responsiveClassName(
                        `flex flex-col text-xs  whitespace-nowrap w-full`,
                        'flex justify-between text-xs items-center whitespace-nowrap w-full'
                      )}
                    >
                      <div className={tw`flex gap-x-1 items-center`}>
                        <p>{item?.branch?.name}</p>
                        <p>{item?.extra_data?.phone_number}</p>
                      </div>
                      <p className={tw`leading-tight `}>
                        {moment(item?.created).format('YY-MM-DD h:mm:ss A')}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div>
          <p>Remarks</p>
          <div className={tw`text-xs md:text-md`}>
            <div className={tw`max-h-[40svh] overflow-y-auto `}>
              {remarks?.results?.map((item, index) => (
                <RecursiveComment
                  key={item?.id}
                  item={item}
                  setComment={setComment}
                />
              ))}
            </div>

            <form
              className={tw`px-6 mt-1  relative`}
              onSubmit={handleSubmit((data: any) =>
                handleCreateReview(data, comment?.id)
              )}
            >
              {comment && (
                <div className={tw`my-1 border-t-[1px] `}>
                  <div className='flex justify-between w-full items-center'>
                    <p className={tw`text-base`}>
                      Replying to {comment?.user?.name}
                    </p>
                    <div
                      className={tw`cursor-pointer`}
                      onClick={() => setComment('')}
                    >
                      <CrossIcon />
                    </div>
                  </div>

                  <p className={tw`text-gray-500 ml-2`}>{comment?.comment}</p>
                </div>
              )}
              <textarea
                autoComplete='off'
                placeholder='Write a comment...'
                {...register('comment')}
                className={tw`text-gray-500 w-full focus:outline-none border-[2px] border-[#828282]  px-2 py-1 rounded-lg`}
                rows={4}
              />
              <button
                className={tw`absolute right-8 bottom-2`}
                type='submit'
                disabled={isPostLoading || false}
              >
                <CommentIcon />
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
export default OrderDetailPage;

export function Loader() {
  return (
    <span
      className={tw`w-[10ch] animate-pulse inline-block h-[1ch] rounded-md bg-gray-500`}
    ></span>
  );
}
